import React from 'react'
import { Button, FormControl, Grid, TextField } from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Stack } from '@mui/material'
import NumberFormat from 'react-number-format'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
import { Table25 } from './Tables/TableSec2/Table25'
import Table26 from './Tables/TableSec2/Table26'
import { Table272 } from './Tables/TableSec2/Table272'
import { Table271 } from './Tables/TableSec2/Table271'
import Moment from 'moment'
import { useFormTechnicalAssistance } from '../../../../context/TechnicalAssistanceContext'
import { useAsistencia } from '../../../../context/AsistenciaContext'

export const AsistenciaSeccion2View = (props) => {
  const { assistanceForm } = useFormTechnicalAssistance()
  const { goToStep } = props
  const [, dispatch] = useAsistencia()

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    goToStep(1)
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  const formik = useFormik({
    validateOnChange: false,
    enableReinitialize: true,
    initialValues: {
      TechnicalAssistanceName: assistanceForm.TechnicalAssistanceName,
      MainNeeds: assistanceForm.MainNeeds,
      FacedLimitations: assistanceForm.FacedLimitations,
      IdentifiedObstacles: assistanceForm.IdentifiedObstacles,
      GeneralObjective: assistanceForm.GeneralObjective,
      SpecificObjective: assistanceForm.SpecificObjective,
      SpecificObjective2: assistanceForm.SpecificObjective2,
      SpecificObjective3: assistanceForm.SpecificObjective3,
      NecessaryImplementationActivities:
        assistanceForm.NecessaryImplementationActivities,
      ActionsForInclusionOfWomen: assistanceForm.ActionsForInclusionOfWomen,
      StartExecutionPeriod: assistanceForm.StartExecutionPeriod
        ? Moment(assistanceForm.StartExecutionPeriod)
            .format('YYYY-MM-DD')
            .toString()
        : '',
      EndExecutionPeriod: assistanceForm.EndExecutionPeriod
        ? Moment(assistanceForm.EndExecutionPeriod)
            .format('YYYY-MM-DD')
            .toString()
        : '',
      NumberOfStudies: assistanceForm.NumberOfStudies,
      TrainedWomenNumber: assistanceForm.TrainedWomenNumber,
      TrainedMenNumber: assistanceForm.TrainedMenNumber,
      IdentifiedProblemsImprove: assistanceForm.IdentifiedProblemsImprove,
      NumberOfParticipants: assistanceForm.NumberOfParticipants,
      TraineeAgeRange1: assistanceForm.TraineeAgeRange1,
      TraineeAgeRange2: assistanceForm.TraineeAgeRange2,
      TraineeAgeRange3: assistanceForm.TraineeAgeRange3,
      TraineeAgeRange4: assistanceForm.TraineeAgeRange4,
      IndigenousCommunitiesNumber: assistanceForm.IndigenousCommunitiesNumber,
    },

    onSubmit: (values) => {},
  })

  return (
    <>
      <form id="Sec1-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">
            Información sobre la Asistencia Técnica solicitada
          </h1>
          <br />
        </Grid>

        <Grid
          container
          spacing={1}
          className="input__container"
          style={{ marginBottom: '3%' }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              <b> 1. Nombre de la asistencia técnica: </b>
              {''}
              <span style={{ color: 'red' }}>*</span>
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FormControl style={{ width: '100%' }}>
              <TextField
                id="IdCurrencyUser"
                name="IdCurrencyUser"
                style={{ width: '100%' }}
                variant="outlined"
                value={formik.values.TechnicalAssistanceName}
                disabled
              />
            </FormControl>
          </Grid>
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2. Justificación, principales necesidades y limitaciones de línea
              base
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Por favor, brinde información sobre la justificación para
                  solicitar la asistencia técnica.
                </label>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.1. Principales necesidades:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Describa las necesidades que tiene la MIPYME, y que le
                    impiden/reducen su desarrollo y crecimiento (desafíos para
                    el desarrollo de su negocio, la implementación de medidas de
                    mitigación del impacto ambiental y de adaptación al cambio
                    climático, la incorporación de mujeres y/o jóvenes; entre
                    otros)
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Principales necesidades"
                      customInput={TextField}
                      value={formik.values.MainNeeds}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.2. Limitaciones enfrentadas:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Explique cuáles son los aspectos o circunstancias que le
                    limitan/impiden solucionar los problemas identificados, por
                    los que solicita la Asistencia Técnica. Se entienden como
                    limitación, un factor que reduce la
                    productividad/rentabilidad de la MIPYME
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Limitaciones enfrentadas"
                      customInput={TextField}
                      value={formik.values.FacedLimitations}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.3. Defina los problemas identificados que se pretende
                    mejorar: <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Detalle, cuáles de los problemas identificados desea atender
                    para mejorar o solucionar la situación que quiere resolver
                    mediante la ejecución de la Asistencia Técnica. Se entiende
                    como problema, un factor que entorpece la operación de la
                    MIPYME
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Problemas identificados"
                      customInput={TextField}
                      value={formik.values.IdentifiedProblemsImprove}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.4. Obstáculos identificados, para la implementación
                    exitosa del subproyecto:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Explique cuáles son los obstáculos que desea
                    reducir/eliminar y que le permitirá ejecutar el subproyecto
                    para el cual recibirá/ha recibido un crédito. Se entiende
                    como obstáculo, un factor que detiene a la MIPYME.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Obstáculos identificados"
                      customInput={TextField}
                      value={formik.values.IdentifiedObstacles}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3. Objetivos principales de la asistencia técnica
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione un objetivo general y mínimo dos objetivos
                  específicos (máximo 3) de la asistencia técnica.
                </label>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.1. Objetivo general:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir de la forma más clara posible, el resultado que se
                    desea alcanzar por medio de la asistencia técnica.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo general"
                      customInput={TextField}
                      value={formik.values.GeneralObjective}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.2. Objetivo específico I:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir un paso necesario (de tipo técnico, financiero,
                    productivo y/o comercial) para alcanzar el objetivo general
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo específico"
                      customInput={TextField}
                      value={formik.values.SpecificObjective}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.3. Objetivo específico II:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir un paso necesario (de tipo técnico, financiero,
                    productivo y/o comercial) para alcanzar el objetivo general
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo específico"
                      customInput={TextField}
                      value={formik.values.SpecificObjective2}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.4. Objetivo específico III:
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir un paso necesario (de tipo técnico, financiero,
                    productivo y/o comercial) para alcanzar el objetivo general.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo específico"
                      customInput={TextField}
                      value={formik.values.SpecificObjective3}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              4. Descripción técnica de la asistencia solicitada
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione una descripción detallada de la asistencia técnica
                  requerida.
                </label>
              </Grid>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    4.1. Modalidad de apoyo:
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      id="IdCurrencyUser"
                      name="IdCurrencyUser"
                      style={{ width: '100%' }}
                      variant="outlined"
                      disabled
                      value={
                        assistanceForm.IdTechnicalAssistanceType === 4
                          ? 'Asistencia técnica para pre-inversión de MIPYME'
                          : assistanceForm.IdTechnicalAssistanceType === 5
                          ? 'Construcción de capacidades para MIPYME'
                          : assistanceForm.IdTechnicalAssistanceType === 3
                          ? 'Construcción de capacidades para IFI'
                          : ''
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.2. Actividades necesarias para su implementación:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Detalle las actividades requeridas para ejecutar la
                    Asistencia Técnica (Ejem: 1. Diseño de Términos de
                    Referencia, 2. Contratación de consultor, 3. Diseño y
                    desarrollo de capacitación, 4. Informe final de la
                    actividad)
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder=" Actividades necesarias"
                      customInput={TextField}
                      value={formik.values.NecessaryImplementationActivities}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.3. Número de participantes:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Indique el número de personas que participarán en la
                    asistencia técnica (Ejem: número de personas capacitadas,
                    número de personas que apoyarán la Asistencia Técnica como
                    contraparte de la empresa).
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="numberAss"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      allowNegative="false"
                      disabled
                      value={formik.values.NumberOfParticipants}
                      inputProps={{ maxLength: 4 }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.4. Acciones para inclusión de mujeres:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Describa las acciones que se tomarán para asegurar la
                    participación de mujeres en las actividades por desarrollar.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Acciones para inclusión de mujeres"
                      customInput={TextField}
                      value={formik.values.ActionsForInclusionOfWomen}
                      disabled
                    ></textarea>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5. Presupuesto desglosado
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} style={{ alignItems: 'center' }}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Para cada rubro (solamente los que se asocien con la ejecución
                  de la Asistencia Técnica solicitada), desglose el monto
                  requerido con fondos CAMBIO, y con fondos de contraparte.
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={3} sm={3} md={3} className="input__container">
                <label>5.1. Moneda:</label>
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControl fullWidth>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    sx={{ width: 220 }}
                    disabled
                    value={assistanceForm.NameCurrency}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Table25
                  IdCurrency={assistanceForm.IdCurrency}
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  formik={formik.setFieldValue}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              6. Cronograma de ejecución previsto
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  6.1. Período estimado de ejecución.{''}
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Establezca el periodo de tiempo que se estima para ejecutar
                  cada una de las actividades de las actividades definidas para
                  ejecutar la Asistencia (Ejem: 1. Diseño de Términos de
                  Referencia, 2. contratación de consultor, 3. diseño y
                  desarrollo de capacitación, 4. informe final de la actividad)
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack component="form" noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Desde"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={formik.values.StartExecutionPeriod}
                      disabled
                    />
                  </Stack>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack component="form" noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Hasta"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={formik.values.EndExecutionPeriod}
                      disabled
                    />
                  </Stack>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  6.2. Marque en el cronograma los meses en que se estima se
                  implementará la asistencia técnica de acuerdo con cada
                  actividad principal.
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                {/* Cronograma */}
                <Table26
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  StartExecutionPeriod={formik.values.StartExecutionPeriod}
                  EndExecutionPeriod={formik.values.EndExecutionPeriod}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.NumberOfStudies ||
              formik.errors.validateTable271 ||
              formik.errors.TrainedWomenNumber ||
              formik.errors.TrainedMenNumber ||
              formik.errors.TotalByGender ||
              formik.errors.TraineeAgeRange1 ||
              formik.errors.TraineeAgeRange2 ||
              formik.errors.TraineeAgeRange3 ||
              formik.errors.TraineeAgeRange4 ||
              formik.errors.TotalByRange ||
              formik.errors.IndigenousCommunitiesNumber ||
              formik.errors.validateTable272
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              7. Productos esperados
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Indique los productos que espera obtener como resultado de la
                  ejecución de la Asistencia Técnica.
                </label>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      7.1. Número de estudios / evaluaciones{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="numberAss"
                        style={{ width: '100%' }}
                        customInput={TextField}
                        thousandSeparator={true}
                        variant="outlined"
                        allowNegative="false"
                        disabled
                        value={formik.values.NumberOfStudies}
                        inputProps={{ maxLength: 4 }}
                      />
                    </FormControl>
                  </Grid>{' '}
                </Grid>

                <Grid
                  container
                  spacing={1}
                  className="input__container"
                  style={{ marginBottom: '3%' }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <Table271
                      IdTechnicalAssistanceAnswer={
                        assistanceForm.IdTechnicalAssistanceAnswer
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    7.2. Números de personas capacitadas por género:
                  </label>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '1%',
                    paddingLeft: '3%',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                    <label className="responsiveLabel">
                      1. Número de mujeres:
                    </label>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="fullName"
                        style={{ width: '100%' }}
                        allowNegative={false}
                        customInput={TextField}
                        variant="outlined"
                        disabled
                        value={formik.values.TrainedWomenNumber}
                        inputProps={{ maxLength: 4 }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '1%',
                    paddingLeft: '3%',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                    <label className="responsiveLabel">
                      2. Número de hombres:
                    </label>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="fullName"
                        style={{ width: '100%' }}
                        allowNegative={false}
                        customInput={TextField}
                        variant="outlined"
                        disabled
                        value={formik.values.TrainedMenNumber}
                        inputProps={{ maxLength: 4 }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '1%',
                    paddingLeft: '3%',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                    <label className="responsiveLabel">
                      <b>Total de personas capacitadas por género:</b>
                    </label>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="fullName"
                        style={{ width: '100%' }}
                        allowNegative={false}
                        customInput={TextField}
                        variant="outlined"
                        value={
                          formik.values.TrainedWomenNumber +
                          formik.values.TrainedMenNumber
                        }
                        disabled
                        error={formik.errors.TotalByGender}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      7.3. Números de personas capacitadas por rango de edad:
                    </label>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">18-30:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          disabled
                          value={formik.values.TraineeAgeRange1}
                          inputProps={{ maxLength: 4 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">31-45:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          disabled
                          value={formik.values.TraineeAgeRange2}
                          inputProps={{ maxLength: 4 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">46-60:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          disabled
                          value={formik.values.TraineeAgeRange3}
                          inputProps={{ maxLength: 4 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">61- Adelante:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          disabled
                          value={formik.values.TraineeAgeRange4}
                          inputProps={{ maxLength: 4 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">
                        <b>Total de personas capacitadas por rango de edad:</b>
                      </label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          inputProps={{ maxLength: 4 }}
                          disabled
                          value={
                            formik.values.TraineeAgeRange2 +
                            formik.values.TraineeAgeRange3 +
                            formik.values.TraineeAgeRange1 +
                            formik.values.TraineeAgeRange4
                          }
                          error={formik.errors.TotalByRange}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      7.4. Comunidades indígenas:
                    </label>
                  </Grid>

                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={4} sm={4} md={4}>
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          Número de comunidades indígenas
                        </label>
                      </Grid>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="numberAss"
                          style={{ width: '100%' }}
                          customInput={TextField}
                          thousandSeparator={true}
                          variant="outlined"
                          allowNegative="false"
                          disabled
                          value={formik.values.IndigenousCommunitiesNumber}
                          inputProps={{ maxLength: 2 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1} className="input__container">
                    {/* Tabla Asistencia */}
                    <Grid item xs={12} sm={12} md={12}>
                      <Table272
                        IdTechnicalAssistanceAnswer={
                          assistanceForm.IdTechnicalAssistanceAnswer
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="button__container">
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'left' }}
            className="continerButtonNav"
          >
            <Button
              onClick={() => previous()}
              variant="contained"
              className="button__wizard button__previous"
            >
              Anterior
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'right' }}
            className="continerButtonNav"
          >
            <Grid container>
              <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                {assistanceForm.IdBeneficiaryType === 2 ? (
                  <Button
                    type="button"
                    className="button__wizard button__next"
                    onClick={() => next()}
                  >
                    Siguiente
                  </Button>
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
